import { CLOUD_STORAGE_CDN } from '@pig-common/models/buildtime-constant'
import { IAchievementItemProps } from '@pig-common/types/Achievement.type'

export const achievementImageUrl = (
  achievementUid?: IAchievementItemProps['achievementUid'],
) =>
  `${CLOUD_STORAGE_CDN}/pigspin-assets/loyalty/achievement/${achievementUid}/achievement.webp`
